import type {AccessMe, ProjectAccess} from './accessApi';
export type AccessAction='read'|'content'|'write'|'execute'|'compare'|'review'|'export'|'members'|'create_run';
export function projectAllows(project:ProjectAccess,action:AccessAction){
 return action==='create_run'?project.actions.includes('write')||project.actions.includes('execute'):project.actions.includes(action);
}
export function permittedProjects(me:AccessMe|undefined,selected:string|undefined){
 return (me?.projects??[]).filter(p=>!selected||p.id===selected);
}
export function allows(me:AccessMe|undefined,selected:string|undefined,action:AccessAction){
 if(!me)return false;
 const projects=permittedProjects(me,selected);
 if(selected&&!projects.length)return false;
 if(me.system_admin)return action==='create_run'?projects.length>0:true;
 return projects.some(p=>projectAllows(p,action));
}
export const actionLabels:Record<string,string>={read:'查看结果',content:'查看文本与音频',write:'维护数据',execute:'启动计费任务',compare:'创建对比',review:'评分与听审',export:'导出',members:'管理成员',credentials:'管理凭证'};
